import React, { useState, useRef, useEffect, useCallback } from 'react'
import useLiquid from 'src/shared/service/use_liquid'

export default function CtrlC({node, ...props}) {
  const renderLiquid = useLiquid()
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if(copied) {
      setTimeout(function() {
        setCopied(false)
      }, props.delay || 2000)
    }
  }, [copied])


  if(copied) {
    return <div dangerouslySetInnerHTML={{ __html: renderLiquid(props["data-success-text"])}}/>
  }

  const renderedText = renderLiquid(props["data-value"])

  return <div onClick={() => {
      console.log("Copied", renderedText)
      navigator.clipboard.writeText(renderedText)
      setCopied(true)}
    }>
      {props.children}
    </div>
}


